var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleTable',{attrs:{"formclass":"Exam/form","endpoint":"exams","aditionalColumns":_vm.headers,"inlineToggle":"","hideDelete":""}},[[_c('h1',[_vm._v("Cadastro de Exames")]),_c('v-divider',{staticClass:"mb-4"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }